/**
 * @description AES 处理
 */
import CryptoJS from 'crypto-js'

class Crypto {
    constructor (options) {
        this.key = (options && options.key) || ''
        this.options = {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }
    }

    static enMD5 (word) {
        return CryptoJS.MD5(word).toString()
    }

    setCryptoKey (key) {
        this.key = key ? CryptoJS.enc.Utf8.parse(key) : ''
    }

    // ase解密方法
    decrypt (word) {
        const hexStr = CryptoJS.enc.Hex.parse(word)
        const ciphertext = CryptoJS.enc.Base64.stringify(hexStr)
        return JSON.parse(CryptoJS.AES.decrypt(ciphertext, this.key, this.options).toString(CryptoJS.enc.Utf8))
    }

    // ase加密方法
    encrypt (word) {
        console.log(this.key, 'dataEncrypdataEncrypdataEncrypdataEncryp')
        // const ciphertext = CryptoJS.enc.Utf8.parse(JSON.stringify(word));
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(word), this.key, this.options)
        return encrypted.ciphertext.toString()
    }

    encryptss (word, key) {
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(word), key, this.options)
        return encrypted.ciphertext.toString()
    }
}
export default new Crypto()
